module.exports = __webpack_public_path__ + "static/img/Mobiflix.fbab832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiflix/imgs/Mobiflix.png
// module id = 1692
// module chunks = 0